import { useStore } from '../../components/state/zustand-store';
import { useTheme } from '@mui/material/styles';
import Lock from '@mui/icons-material/Lock';

export default function LockCustomIcon() {
  const { colorMode } = useStore();
  const theme = useTheme();

  return (
    <>
      <svg width={0} height={0}>
        <linearGradient id="lock-gradient" x1="100%" y1="0%" x2="0%" y2="0%">
          <stop
            offset="0%"
            stopColor={
              colorMode === 'light'
                ? theme.palette.violet[400]
                : theme.palette.violet[400]
            }
          />
          <stop
            offset="100%"
            stopColor={
              colorMode === 'light'
                ? theme.palette.cyan[400]
                : theme.palette.cyan[400]
            }
          />
        </linearGradient>
      </svg>

      <Lock
        sx={{
          fontSize: '18px',
          fill: 'url(#lock-gradient)',
        }}
      />
    </>
  );
}
